import React, { useEffect, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { ReactFormGenerator } from "react-form-builder2";
import * as variables from "utils/ReactFormBuilderVariables";
import { sanitizeItems } from "utils/formDataHelper";
import { Wrapper } from './Theme';
import { formatDateInFormData } from "./formDataHelper";

const FormGeneratorComponent = ({ formStructure, syncValuesWithFormik, answerData }) => {
  const formBuilderRef = useRef(null);
  const formData = formatDateInFormData(formStructure);

  useEffect(() => {
    if (formBuilderRef.current) {
      formBuilderRef.current.querySelector('input').focus();
    }
  }, [formBuilderRef]);

  const filterFormData = sanitizeItems(formData);


  return (
    <Wrapper ref={formBuilderRef}>
      <ReactFormGenerator

        variables={variables}
        data={filterFormData} // Question data
        answer_data={answerData || []} // Answer data, only used if loading a pre-existing form with values.
        task_id={12} // Used to submit a hidden variable with the id to the form from the database.
        onChange={(event) => {
          syncValuesWithFormik(event)
        }}
        onBlur={(event) => {
          syncValuesWithFormik(event)
        }}
        hide_actions
      />
    </Wrapper>
  );
};

export default FormGeneratorComponent;